const authEn = {
	MY_PROFILE: 'My Profile',
	LOGOUT: 'Log Out',
	LOGIN: 'Sign In',
	REGISTER: 'Create Account',
	EMAIL: 'Email',
	PASSWORD: 'Password',
	PASSWORD_AGAIN: 'Confirm password',
	LOST_YOUR_PASSWORD: 'Lost your password?',
	REQUEST_A_NEW_PASSWORD: 'Request a New One!',
	BACK_TO_LOGIN: 'Back to Sign In',
	SAVE_PASSWORD: 'Save password',
	NEW_PASSWORD_SET_MESSAGE: 'Your new password has been set. Please sign in.',
	NEW_PASSWORD_SET_FAILED_MESSAGE: 'We were unable to set your new password. Please try again.',
	PLEASE_SET_PASSWORD_MESSAGE: 'Please enter your new password twice.',
	PLEASE_SET_EMAIL_MESSAGE: 'Please enter the email address associated with your account.',
	PLEASE_SET_EMAIL_DESC: 'We will send a password reset link to the email address provided.',
	NEW_PASSWORD_REQUEST: 'Send email',
	NEW_PASSWORD_REQUEST_MESSAGE: 'We have sent a password reset email to the address provided. Please check your inbox.',
	NEW_PASSWORD_REQUEST_FAILED: 'A password reset cannot be requested for the email address provided.'
};

export default authEn;